<template>
    <div class="data_area ps-03">
        <div class="data_population">
            <!-- <h4>워크넷 채용정보</h4>
            <span class="txt_r">(일요일 - 123개)</span> -->
            
            <div class="lifemap_list ps-03 scroll">
                <ul class="list">
                    <li v-for="(work, idx) in dataList" :key="idx" @click.prevent="selectJob(idx)"  v-if="idx >= (page - 1) * listSize && idx < page * listSize">
                        <template v-if="['01', '02', '04', '05'].includes(work.type)">
                            <!-- <div class="tit">
                                <span class="ct_11" v-if="checkEndDt(work.endDt)">진행중</span>
                                <span class="ct_15" v-else>마감</span>
                                <span class="ct_12">정규직</span>
                                <span class="ct_13" v-if="!!work.career && work.type == '01'">{{ work.career }}</span> 
                                <span class="ct_14" v-if="!!work.edu && work.type == '01'">{{ work.edu }}</span>
                            </div> -->
                            <div class="txt">
                                <span class="t_orange" style="color: rgb(251, 242, 103) !important">[{{ work.company }}]</span>
                                {{ work.title }}
                                <a v-if="!!work.url" class="btn_url" @click.prevent="openUrl(work.url)" style="cursor:pointer;"> <i></i>바로가기</a>
                                <!-- <a class="btn_map"> <i></i> 지도</a> -->
                            </div>
    
                            <div class="lifemap_tbl ps-01 mt10 " v-show="idx == selectedJobIdx && work.type != '05'">
                                <dl>
                                    <!-- <dt>직종</dt>
                                    <dd></dd> -->
                                    <template v-if="!!work.career">
                                        <dt>경력</dt>
                                        <dd>{{ work.career }}</dd>
                                    </template>
    
                                    <template v-if="!!work.edu">
                                        <dt>학력</dt>
                                        <dd>{{ work.edu }}</dd>
                                    </template>
    
                                    <template v-if="!!work.payment">
                                        <dt>입금</dt>
                                        <dd>{{ work.payment }}</dd>
                                    </template>
    
                                    <template v-if="!!work.workCondition">
                                        <dt>근무형태</dt>
                                        <dd>{{ work.workCondition }}</dd>
                                    </template>
                                    
                                    <template v-if="!!work.endDt">
                                        <dt>마감일자</dt>
                                        <dd v-html="setBrDate(work.endDt)" :style="setBrDate(work.endDt).includes('br') ? 'padding-top:0px': ''"></dd>
                                        <!-- <dd>{{ setBrDate(work.endDt) }}</dd> -->
                                    </template>
                                    
                                    <template v-if="!!work.hireCondition">
                                        <dt>고용형태</dt>
                                        <dd v-html="setBrText(work.hireCondition)" :style="setBrText(work.hireCondition).includes('br') ? 'padding-top:0px' : ''"></dd>
                                        <!-- <dd>{{ work.hireCondition }}</dd> -->
                                    </template>
    
                                    <template v-if="!!work.addr">
                                        <dt>근무지역</dt>
                                        <dd>{{ work.addr }}</dd>
                                    </template>

                                    <template v-if="!!work.incrude1">
                                        <dt>공고유형1</dt>
                                        <dd>{{ work.incrude1 }}</dd>
                                    </template>
                                    
                                    <template v-if="!!work.incrude2">
                                        <dt>공고유형2</dt>
                                        <dd>{{ work.incrude2 }}</dd>
                                    </template>
                                </dl>
                            </div>
                        </template>
                        <template v-if="['03'].includes(work.type)">
                            <!-- <div class="tit">
                                <span class="ct_11" v-if="checkEndDt(work.realEndDt)">게시기간 내</span>
                                <span class="ct_15" v-else>게시기간 종료</span>
                                <span class="ct_13" v-if="!!work.career">{{ work.career }}</span> 
                                <span class="ct_14" v-if="!!work.edu">{{ work.edu }}</span>
                            </div> -->
                            <div class="txt">
                                <span class="t_orange" style="color: rgb(251, 242, 103) !important">[{{ work.company }}]</span>
                                {{ work.title }}
                                <a class="btn_url" @click.prevent="openUrl(work.url)" style="cursor:pointer;"> <i></i>바로가기</a>
                                <!-- <a class="btn_map"> <i></i> 지도</a> -->
                            </div>

                            <div class="lifemap_tbl ps-01 mt10 " v-show="idx == selectedJobIdx">
                                <dl>
                                    <!-- <dt>직종</dt>
                                    <dd></dd> -->
                                    <template v-if="!!work.chargerInstt">
                                        <dt>담당기관</dt>
                                        <dd>{{ work.chargerInstt }}</dd>
                                    </template>
    
                                    <template v-if="!!work.chargerDept">
                                        <dt>담당부서</dt>
                                        <dd>{{ work.chargerDept }}</dd>
                                    </template>

                                    <template v-if="!!work.email">
                                        <dt>이메일</dt>
                                        <dd>{{ work.email }}</dd>
                                    </template>
                                    
                                    <template>
                                        <dt>전화번호</dt>
                                        <dd>{{ work.tel }}</dd>
                                    </template>
    
                                    <template v-if="!!work.endDt">
                                        <dt>게시시작일</dt>
                                        <dd>{{ work.endDt }}</dd>
                                    </template>
                                    
                                    <template v-if="!!work.realEndDt">
                                        <dt>게시종료일</dt>
                                        <dd>{{ work.realEndDt }}</dd>
                                        <!-- <dd>{{ setBrDate(work.endDt) }}</dd> -->
                                    </template>

                                    
                                    <!-- <template v-if="!!work.fileDownloadUrl">
                                        <dt>첨부파일</dt>
                                        <dd style="cursor:pointer;position: relative; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" class="t_orange"><a @click.prevent="openUrl(work.fileDownloadUrl)">{{ work.fileName }}</a></dd>
                                    </template> -->
                                </dl>
                            </div>
                        </template>
                    </li>
                    <li class="nodata" v-if="dataList.length == 0">
                        <div class="txt" style="text-align:center;">
                            검색된 결과가 없습니다. 검색어를 다시 확인해주세요.
                        </div>
                    </li>
                    <!-- <li>
                        <div class="tit"><span class="ct_11">진행중</span> <span class="ct_12">정규직</span> <span class="ct_13">경력</span> <span class="ct_14">학력무관</span></div>
                        <div class="txt">
                            <span class="t_blue3">[태화기독교사회복지관]</span>
                            태화기독교사회복지관 교사직(계약직/사회체육지도교사... 
                            <a href="" class="btn_url"> <i></i> url</a>
                            <a href="" class="btn_map"> <i></i> 지도</a>
                        </div>
                    </li>
                    <li>
                        <div class="tit"><span class="ct_11">진행중</span> <span class="ct_12">정규직</span> <span class="ct_13">경력</span> <span class="ct_14">학력무관</span></div>
                        <div class="txt">
                            <span class="t_blue3">[태화기독교사회복지관]</span>
                            태화기독교사회복지관 교사직(계약직/사회체육지도교사... 
                            <a href="" class="btn_url"> <i></i> url</a>
                            <a href="" class="btn_map"> <i></i> 지도</a>
                        </div>

                        <div class="lifemap_tbl ps-01 mt10 ">
                            <dl>
                                <dt>직종</dt>
                                <dd></dd>

                                <dt>경력</dt>
                                <dd>관계없엄</dd>

                                <dt>학력</dt>
                                <dd>학력무관</dd>

                                <dt>입금</dt>
                                <dd>206만원 ~ 250만원</dd>

                                <dt>근무형태</dt>
                                <dd>주5일근무</dd>
                                <dt>마감일자</dt>
                                <dd>채용시까지 24-04-20</dd>

                                <dt>고용형태</dt>
                                <dd>기간의 정함이 없는 근로 계약</dd>

                                <dt>근무지역</dt>
                                <dd>시울특별시 관악구 관악로 111 (봉천동) 송호빌딩 2층</dd>
                            </dl>
                        </div>

                    </li>
                    <li>
                        <div class="tit"><span class="ct_11">진행중</span> <span class="ct_12">정규직</span> <span class="ct_13">경력</span> <span class="ct_14">학력무관</span></div>
                        <div class="txt">
                            <span class="t_blue3">[태화기독교사회복지관]</span>
                            태화기독교사회복지관 교사직(계약직/사회체육지도교사... 
                            <a href="" class="btn_url"> <i></i> url</a>
                            <a href="" class="btn_map"> <i></i> 지도</a>
                        </div>

                        <div class="lifemap_tbl ps-01 mt10 ">
                            <dl>
                                <dt>직종</dt>
                                <dd></dd>

                                <dt>경력</dt>
                                <dd>관계없엄</dd>

                                <dt>학력</dt>
                                <dd>학력무관</dd>

                                <dt>입금</dt>
                                <dd>206만원 ~ 250만원</dd>

                                <dt>근무형태</dt>
                                <dd>주5일근무</dd>
                                <dt>마감일자</dt>
                                <dd>채용시까지 24-04-20</dd>

                                <dt>고용형태</dt>
                                <dd>기간의 정함이 없는 근로 계약</dd>

                                <dt>근무지역</dt>
                                <dd>시울특별시 관악구 관악로 111 (봉천동) 송호빌딩 2층</dd>
                            </dl>
                        </div>
                    </li>
                    <li>
                        <div class="tit"><span class="ct_11">진행중</span> <span class="ct_12">정규직</span> <span class="ct_13">경력</span> <span class="ct_14">학력무관</span></div>
                        <div class="txt">
                            <span class="t_blue3">[태화기독교사회복지관]</span>
                            태화기독교사회복지관 교사직(계약직/사회체육지도교사... 
                            <a href="" class="btn_url"> <i></i> url</a>
                            <a href="" class="btn_map"> <i></i> 지도</a>
                        </div>
                    </li>
                    <li>
                        <div class="tit"><span class="ct_11">진행중</span> <span class="ct_12">정규직</span> <span class="ct_13">경력</span> <span class="ct_14">학력무관</span></div>
                        <div class="txt">
                            <span class="t_blue3">[태화기독교사회복지관]</span>
                            태화기독교사회복지관 교사직(계약직/사회체육지도교사... 
                            <a href="" class="btn_url"> <i></i> url</a>
                            <a href="" class="btn_map"> <i></i> 지도</a>
                        </div>
                    </li> -->
                </ul>
            </div>

            <div class="pagination">
                <div class="first" @click.prevent="moveFirst()"></div>
                <div class="prv" @click.prevent="movePrev()"></div>
                <ul class="pag">
                    <li v-for="i in end" v-if="i > start" :class="{on: i === page}"
                        @click.prevent="movePage(i)">{{ i }}</li>
                </ul>
                <div class="next" @click.prevent="moveNext()"></div>
                <div class="last" @click.prevent="moveLast()"></div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { $_WC } from '@/confs/common.const.js';

export default {
    data() {
        return {
            reg: /[^0-9]/g,
            selectedJobIdx: -1,
            listSize: 9,
            pageSize: 5,
            page: 1,
            searchVal: '',
        }
    },
    watch: {
        searchVal: {
            immediate: false,
            handler(nv, ov) {
                this.moveFirst();
            }
        },
    },
    components: {
    },
    computed: {
        ...mapGetters({
            selectedLfcnvncTab: 'getSelectedLfcnvncTab',
            workIncrudeInfo : 'getWorkIncrudeInfo',
        }),
        dataList() {
            let list = [];
            if(!!this.workIncrudeInfo) {
                if(!!this.searchVal) {
                    list = this.workIncrudeInfo.filter(d => {
                        return d.title.includes(this.searchVal) || d.company.includes(this.searchVal);
                    });
                } else {
                    list = this.workIncrudeInfo;
                }
                
            }
            return list;
        },
        start(){
            return Math.floor((this.page - 1) / this.pageSize) * this.pageSize;
        },
        end(){
            return Math.ceil(this.totalCount / this.listSize) < this.start + this.pageSize ? Math.ceil(this.totalCount / this.listSize) : this.start + this.pageSize;
        },
        totalCount() {
            return this.dataList.length;
        },
    },
    created() {
    },
    mounted() {
        this.$eventBus.$on('Set::Search::Value', searchVal => {
            this.searchVal = searchVal;
        });
    },
    methods: {
        openUrl(url) {
            if(!url.includes('http')) {
                url = 'https://' + url;
            }
            window.open(url);
        },
        checkEndDt(endDt) {
            if(!!endDt) {
                let date = new Date().format('yyMMdd');
                let endDate = endDt.replace(this.reg, "");
                if(Number(date) < Number(endDate)) {
                    return true;
                }
            }
            return false;
        },
        setBrDate(endDt) {
            let returnVal = endDt;
            let list = returnVal.split('  ');
            if(list.length > 1) {
                returnVal = list[0] + '<br />' + list[1];
            }
            return returnVal;
        },
        setBrText(str) {
            if(str.length > 8) {
                str = str.substring(0, 9) + '<br />' + str.substring(9, str.length);
            }
            return str;
        },
        selectJob(idx) {
            if(this.selectedJobIdx == idx) {
                this.selectedJobIdx = -1;
            } else {
                this.selectedJobIdx = idx;
            }
        },
        movePage(page) {
            this.page = page;
        },
        movePrev(){
            if(this.start > 0){
                this.page = this.start;
            }
        },
        moveNext(){
            if(this.listSize * this.end < this.totalCount){
                this.page = this.end + 1;
            }
        },
        moveFirst(){
            this.movePage(1);
        },
        moveLast(){
            this.movePage(Math.ceil(this.totalCount / this.listSize));
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
<style>
.lifeconv_info .lifemap_list .nodata .txt{
    margin: 10% 0%;
}
@media (min-width: 0) and (max-width: 768px) {
    .lifeconv_info .lifemap_list .nodata .txt{
        margin: 30% 0%;
    }
}
</style>